module.exports = __webpack_public_path__ + "media/images/instagram-2f15738b0baee7b273b8497173c18a9e.svg";